import React, { Component } from 'react';
// import SupportingText from '../../common/supportingText/SupportingText';
import HeaderTags from '../../common/headerTags/HeaderTags';
import MusicsPage from '../../components/musics/containers/MusicsPageContainer';
import { getMusicDataIfNeeded, getFilteredMusicDataIfNeeded } from '../../components/musics/actions/MusicsPageActions';
import { fetchArtistsSlidesIfNeeded } from '../../components/artists/actions/ArtistsActions';

const headerTags =
{
    title: 'Músicas - Letras, traduções, vídeos, clipes, álbuns, notícias, lançamentos e muito mais',
    meta:
    {
        description: 'Pesquise e acompanhe tudo sobre os sucessos que tocam na rádio! São letras, traduções e vídeos disponíveis para conferir. Acesse o portal Antena 1!',
        keywords: 'músicas, letras, traduções, vídeos, clipe, álbuns, stop loving her today, girls go wild, castles, love is on the line, adore you',
        'og:title': 'Músicas - Letras, traduções, vídeos, clipes, álbuns, notícias, lançamentos e muito mais',
        'og:description': 'Pesquise e acompanhe tudo sobre os sucessos que tocam na rádio! São letras, traduções e vídeos disponíveis para conferir. Acesse o portal Antena 1!',
        'og:image': 'https://a1media.antena1.com.br/image/share/musicas.png',
    },
};
// const supportingTextInfo = {
//     title: 'Os maiores sucessos do grandes cantores e cantoras',
//     description: `Dos anos de 1960, 1970, 1980, 1990, 2000 e 2010 você encontra aqui na Rádio Antena 1.
//     Conheça os novos e antigos hits dos seus artistas favoritos, leia as letras, traduções e clipes das canções internacionais mais aclamadas!
//     Lost on You, Forever Young, I Feel it Coming, A New Day is Coming e Everything são apenas algumas músicas que você vai conhecer ou se aprofundar sobre.
//     Baixe também o nosso aplicativo e ouça o seu artista favorito, além de outro grandes sucessos do mundo da música. Disponível nas lojas virtuais da Apple Store e Google Play.`,
// };

class Musicas extends Component {
    static fetchData(store, _match, query) {
        const myPromises = [
            store.dispatch(fetchArtistsSlidesIfNeeded()),
        ];

        if (query.letra || query.traducao || query.video || query.busca) {
            const filterOptions = {
                lyrics: query.letra === 'true',
                translation: query.traducao === 'true',
                video: query.video === 'true',
                query: query.busca !== '' ? query.busca : false,
            };

            myPromises.push(store.dispatch(getFilteredMusicDataIfNeeded(30, 0, filterOptions)));
        } else {
            myPromises.push(store.dispatch(getMusicDataIfNeeded(30, 0)));
        }

        return Promise.all(myPromises);
    }

    render() {
        return (
            <div className="pageWrapper tw-container tw-m-auto tw-px-5">
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <MusicsPage />
                {/* <SupportingText title={supportingTextInfo.title} description={supportingTextInfo.description} /> */}
            </div>
        );
    }
}

export default Musicas;
